import React, { useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import { ButtonContainer, StyledButton } from '../../StyledComponets';
import { dateFormatter } from '../../helpers/utilities';

const Notes = (props) => {
  const isEdit  = props.pageType==='edit'
  const notesData = [
    { note: 'Updating program type', noteAt: '2019-10-17T00:00:00', noteBy: 'John Red' },
    { note: 'Added Inverter With supporting text below as a natural lead-in to additional content.', noteAt: '2019-10-17T00:00:00', noteBy: 'Thomas Blue' },
    { note: 'With supporting text below as a natural lead-in to additional content. With supporting text below as a natural lead-in to additional content. With supporting text below as a natural lead-in to additional content. With supporting text below as a natural lead-in to additional content.', noteAt: '2019-10-17T00:00:00', noteBy: 'Geek Green' },
  ];
  return (
    <>
      {isEdit &&
      <>
      <Form.Group controlId="notes">
        <Form.Control
          type="text"
          as="textarea"
          placeholder="Enter Detail description"
          maxLength="400"
        />
      </Form.Group>
      <ButtonContainer><StyledButton btnType="secondary" variant="dark" size="md">
        Add Note
      </StyledButton></ButtonContainer>
      <hr />
      </>
  }
      {notesData?.map((item) => (
        <>
        <Card>
        <Card.Header style={{backgroundColor:'#e7f5fe'}}><Form.Text size="sm" style={{fontWeight:'bold'}}>{item.noteBy}</Form.Text> <Form.Text size="sm" style={{float:'right'}}>{dateFormatter({ value: item?.noteAt })}</Form.Text></Card.Header>
        <Card.Body>
          <Card.Text>
           {item.note}
          </Card.Text>
        </Card.Body>
      </Card>
      <br/>
      </>
      ))}

    </>
  );
};

export default Notes;
